import { Component } from '@angular/core';
import { UtilityService } from '../../Model/utility/utility.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ComboService } from '../../Model/Combo/combo.service';
import { CommonService } from '../../Model/Common/common.service';
import { EmployeeRegistrationService } from '../../Model/EmployeeRegistration/employee-registration.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbNavModule, NgbNav, NgbDatepickerModule, NgbTypeaheadModule, NgbDropdownModule, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import moment from 'moment';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-register-preonbording-setup',
  standalone: true,
  imports: [NgbNavModule, NgbNav, CommonModule, FormsModule, NgbDatepickerModule, NgbTypeaheadModule, NgSelectModule, NgbDropdownModule, DataTablesModule, LoaderComponent],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './register-preonbording-setup.component.html',
  styleUrl: './register-preonbording-setup.component.scss'
})
export class RegisterPreonbordingSetupComponent {
  isDisabled: boolean = false;
  addonURL = ''
  EmpServiceTypes = [] as any;
  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;
  Designations = [] as any;
  Dutys = [] as any;
  Shifts = [] as any;
  Approvals1 = [] as any;
  Approvals2 = [] as any;

  PreJoiningDate = null as any;
  PostJoiningDate = null as any;
  IsReportingToNotApplicable = false;
  PreonboardinSetupDetail = {
    EmpMasterId: 0,
    EmployeeName: null,
    URLValidity: null,
    EmpServiceTypeId: null,
    ServiceTypeName: null,
    BranchID: null,
    BranchName: null,
    ClientId: null as any,
    ClientName: null,
    SiteId: null as any,
    SiteName: null,
    DesignationId: null as any,
    DesignationName: null,
    //DutyID: null, //
    DutyId: null as any,
    ShiftId: null,
    JoiningDate: null as any,
    //ProbationDate: null as any,
    FirstApproverId: null as any,
    FirstApproverName: null,
    SecondApproverId: null as any,
    SecondApproverName: null,
    EmpType: '',
    Email: null,
    MobileNo: null,
    EmpCode: null,
    SelectType: 'U',
    IsDraft: true,
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    protected common: CommonService,
    private toast: ToastService,
    private employeeRegistration: EmployeeRegistrationService,
    private combo: ComboService,
    private utility: UtilityService,
    private session: SessionService,
    private dateFormat: CustomDateParserFormatter,
    private tooltip: TooltipService,
    private modalService: NgbModal,
  ) {
    this.common.getPageRights();
    this.route.params.subscribe(params => this.PreonboardinSetupDetail.EmpMasterId = parseInt(params['id']));
    this.addonURL = this.router.url.split('/')[2];
  }

  ngOnInit(): void {
    if (this.PreonboardinSetupDetail.EmpMasterId > 0) {
      this.GetData('PreOnBoarding');
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      this.close();
    }
  }

  ComboLoad(Combotype: String, clearChild = true) {
    this.isDisabled = true;
    if (Combotype == 'Branch' && clearChild) {
      this.Branchs = [];
      this.Clients = [];
      this.Sites = [];
      this.Designations = [];
      this.Dutys = [];
      this.PreonboardinSetupDetail.BranchID = null;
      this.PreonboardinSetupDetail.ClientId = null;
      this.PreonboardinSetupDetail.SiteId = null;
      this.PreonboardinSetupDetail.DesignationId = null;
      this.PreonboardinSetupDetail.DutyId = null;
    } else if (Combotype == 'Client' && clearChild) {
      this.Clients = [];
      this.Sites = [];
      this.Designations = [];
      this.Dutys = [];
      this.Approvals1 = [];
      this.Approvals2 = [];
      this.PreonboardinSetupDetail.FirstApproverId = null
      this.PreonboardinSetupDetail.SecondApproverId = null
      this.PreonboardinSetupDetail.ClientId = null;
      this.PreonboardinSetupDetail.SiteId = null;
      this.PreonboardinSetupDetail.DesignationId = null;
      this.PreonboardinSetupDetail.DutyId = null;
    } else if (Combotype == 'Site' && clearChild) {
      this.Sites = [];
      this.Designations = [];
      this.Dutys = [];
      this.PreonboardinSetupDetail.SiteId = null;
      this.PreonboardinSetupDetail.DesignationId = null;
      this.PreonboardinSetupDetail.DutyId = null;
    } else if (Combotype == 'Designation' && clearChild) {
      this.Designations = [];
      this.Dutys = [];
      this.PreonboardinSetupDetail.DesignationId = null;
      this.PreonboardinSetupDetail.DutyId = null;
    } else if (Combotype == 'Duty' && clearChild) {
      this.Dutys = [];
      this.PreonboardinSetupDetail.DutyId = null;
    }

    this.combo.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'Approval1') ? this.PreonboardinSetupDetail.BranchID : 0,
      'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.PreonboardinSetupDetail.ClientId : 0,
      'SiteId': (Combotype == 'Designation' || Combotype == 'Duty') ? this.PreonboardinSetupDetail.SiteId : 0,
      'DesignationId': (Combotype == 'Duty') ? this.PreonboardinSetupDetail.DesignationId : 0,
      'EmpType': this.PreonboardinSetupDetail.EmpType,
      'StateId': 0,
      'DistrictId': 0,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'ServiceType') {
          this.EmpServiceTypes = response.ComboLoad;
        } else if (Combotype == 'Branch') {
          this.Branchs = response.ComboLoad;
        } else if (Combotype == 'Client') {
          this.Clients = response.ComboLoad;
        } else if (Combotype == 'Site') {
          this.Sites = response.ComboLoad;
        } else if (Combotype == 'Designation') {
          this.Designations = response.ComboLoad;
        } else if (Combotype == 'Duty') {
          this.setIsReportingToNotApplicable();
          this.Dutys = response.ComboLoad;
        } else if (Combotype == 'Approval1') {
          this.Approvals1 = response.ComboLoad;
          this.Approvals2 = response.ComboLoad;
        } else if (Combotype == 'Shift') {
          this.Shifts = response.ComboLoad;
        }
        // else if (Combotype == 'Approval2') {
        //   this.Approvals2 = response.ComboLoad;
        //   this.Approvals2Filter = response.ComboLoad;
        // }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  JoiningDateChange(event: any) {
    // this.PreonboardinSetupDetail.ProbationDate = moment(this.dateFormat.format(this.PreonboardinSetupDetail.JoiningDate));
    // this.PreonboardinSetupDetail.ProbationDate = moment(this.PreonboardinSetupDetail.ProbationDate.add({ day: this.common.CompanyParameterValue.ProbationDays }));
    // this.PreonboardinSetupDetail.ProbationDate = this.dateFormat.parse(this.PreonboardinSetupDetail.ProbationDate.format("DD MMM YYYY"))
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'PreJoiningDate') {
          this.PreJoiningDate = this.dateFormat.parse(response.Table[0].PreJoiningDate);
          console.log(this.PreonboardinSetupDetail.EmpType);
          if (this.common.CompanyParameterValue.RestrictFutureDateEntry && this.common.ToLowerCase(this.PreonboardinSetupDetail.EmpType) == 'front') {
            this.PostJoiningDate = this.dateFormat.parse(response.Table[0].FutureJoiningDate);
          }
          if (this.common.CompanyParameterValue.RestrictFutureDateEntryBack && this.common.ToLowerCase(this.PreonboardinSetupDetail.EmpType) == 'back') {
            this.PostJoiningDate = this.dateFormat.parse(response.Table[0].FutureJoiningDateBack);
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async SaveEmpPreOnBoarding() {
    await this.common.getPageRights();
    if (this.common.PageRight.IsEdit) {
      if (this.PreonboardinSetupDetail.FirstApproverId != null && this.PreonboardinSetupDetail.FirstApproverId != '' && this.PreonboardinSetupDetail.FirstApproverId == this.PreonboardinSetupDetail.SecondApproverId) {
        this.toast.show({ message: 'Reporting Manager 1 and Reporting Manager 2 Cannot Be Same ', type: toastTypeEnum.danger });
      } else {
        this.isDisabled = true;
        if (this.PreonboardinSetupDetail.JoiningDate != null) {
          this.PreonboardinSetupDetail.JoiningDate = this.dateFormat.format(this.PreonboardinSetupDetail.JoiningDate);
        }

        // if (this.PreonboardinSetupDetail.ProbationDate != null) {
        //   this.PreonboardinSetupDetail.ProbationDate = this.dateFormat.format(this.PreonboardinSetupDetail.ProbationDate);
        // }

        if (this.PreonboardinSetupDetail.EmpServiceTypeId != null && this.PreonboardinSetupDetail.EmpServiceTypeId > 0) {
          this.PreonboardinSetupDetail.ServiceTypeName = this.EmpServiceTypes.filter((e: any) => e.ServiceTypeID == this.PreonboardinSetupDetail.EmpServiceTypeId)[0].ServiceTypeName;
        }
        if (this.PreonboardinSetupDetail.BranchID != null && this.PreonboardinSetupDetail.BranchID > 0) {
          this.PreonboardinSetupDetail.BranchName = this.Branchs.filter((e: any) => e.BranchMasterID == this.PreonboardinSetupDetail.BranchID)[0].BranchName;
        }
        if (this.PreonboardinSetupDetail.ClientId != null) {
          this.PreonboardinSetupDetail.ClientName = this.Clients.filter((e: any) => e.ClientGroupMasterID == this.PreonboardinSetupDetail.ClientId)[0].ClientGroupName;
        }
        if (this.PreonboardinSetupDetail.SiteId != null && this.PreonboardinSetupDetail.SiteId > 0) {
          this.PreonboardinSetupDetail.SiteName = this.Sites.filter((e: any) => e.SiteMasterID == this.PreonboardinSetupDetail.SiteId)[0].SiteName;
        }
        if (this.PreonboardinSetupDetail.DesignationId != null && this.PreonboardinSetupDetail.DesignationId > 0) {
          this.PreonboardinSetupDetail.DesignationName = this.Designations.filter((e: any) => e.DesignationMasterID == this.PreonboardinSetupDetail.DesignationId)[0].DesignationName;
        }

        if (this.PreonboardinSetupDetail.FirstApproverId != null && this.PreonboardinSetupDetail.FirstApproverId > 0) {
          this.PreonboardinSetupDetail.FirstApproverName = this.Approvals1.filter((e: any) => e.UserMasterId == this.PreonboardinSetupDetail.FirstApproverId)[0].Name;
        }
        if (this.PreonboardinSetupDetail.SecondApproverId != null && this.PreonboardinSetupDetail.SecondApproverId > 0) {
          this.PreonboardinSetupDetail.SecondApproverName = this.Approvals2.filter((e: any) => e.UserMasterId == this.PreonboardinSetupDetail.SecondApproverId)[0].Name;
        }

        this.employeeRegistration.SaveEmpPreOnBoarding(this.PreonboardinSetupDetail).subscribe({
          next: (response) => {
            if (response.Error_Code == '350') {
              if (this.common.CompanyParameterValue.PreOnBoarding_IsURLAutoInitiated || this.common.ToLowerCase(this.addonURL) == 'candidateinitiation') {
                this.SendPreOnBoardingLink();
              } else {
                this.isDisabled = false;
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.router.navigate(['/onboarding/' + this.addonURL + '/' + this.common.ToLowerCase(this.PreonboardinSetupDetail.EmpType)]);
                  }
                });
              }
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
              this.isDisabled = false;
            }
          },
          complete: () => {
            if (this.PreonboardinSetupDetail.JoiningDate != null) {
              this.PreonboardinSetupDetail.JoiningDate = this.dateFormat.parse(this.PreonboardinSetupDetail.JoiningDate);
            }

            // if (this.PreonboardinSetupDetail.ProbationDate != null) {
            //   this.PreonboardinSetupDetail.ProbationDate = this.dateFormat.parse(this.PreonboardinSetupDetail.ProbationDate);
            // }
          },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  async SendPreOnBoardingLink() {
    this.isDisabled = true;
    await new Promise(f => setTimeout(f, 1000));
    this.employeeRegistration.SendPreOnBoardingLink({ DomainName: this.session.GetUserDetails().Domain, EmpMasterId: this.PreonboardinSetupDetail.EmpMasterId, SelectType: 'TimeStamp', EmpCode: this.PreonboardinSetupDetail.EmpCode, IsDraft: this.PreonboardinSetupDetail.IsDraft, Email: this.PreonboardinSetupDetail.Email, MobileNo: this.PreonboardinSetupDetail.MobileNo }).subscribe({
      next: (response) => {
        if (response.Error_Code == '35' || response.Error_Code == '12') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.router.navigate(['/onboarding/' + this.addonURL + '/' + this.common.ToLowerCase(this.PreonboardinSetupDetail.EmpType)]);
            }
          });
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetData(TabName: string) {
    this.isDisabled = true;
    this.employeeRegistration.ESS_EmpRegistration_SearchGet({ 'SelectType': TabName, 'EmpMasterId': this.PreonboardinSetupDetail.EmpMasterId, 'IsDraft': true }).subscribe({
      next: (response) => {
        if (response.Table.toString() != '') {
          this.PreonboardinSetupDetail = response.Table[0];
          if (this.PreonboardinSetupDetail.EmpServiceTypeId == 0 || this.PreonboardinSetupDetail.EmpServiceTypeId == '') {
            this.PreonboardinSetupDetail.EmpServiceTypeId = null
          }
          if (this.PreonboardinSetupDetail.BranchID == 0 || this.PreonboardinSetupDetail.BranchID == '') {
            this.PreonboardinSetupDetail.BranchID = null
          }
          if (this.PreonboardinSetupDetail.ClientId == 0 || this.PreonboardinSetupDetail.ClientId == '') {
            this.PreonboardinSetupDetail.ClientId = null
          }
          if (this.PreonboardinSetupDetail.SiteId == 0 || this.PreonboardinSetupDetail.SiteId == '') {
            this.PreonboardinSetupDetail.SiteId = null
          }
          if (this.PreonboardinSetupDetail.DesignationId == 0 || this.PreonboardinSetupDetail.DesignationId == '') {
            this.PreonboardinSetupDetail.DesignationId = null
          }

          if (this.PreonboardinSetupDetail.FirstApproverId == 0 || this.PreonboardinSetupDetail.FirstApproverId == '') {
            this.PreonboardinSetupDetail.FirstApproverId = null
            this.PreonboardinSetupDetail.FirstApproverName = null
          }

          if (this.PreonboardinSetupDetail.SecondApproverId == 0 || this.PreonboardinSetupDetail.SecondApproverId == '') {
            this.PreonboardinSetupDetail.SecondApproverId = null
            this.PreonboardinSetupDetail.SecondApproverName = null
          }

          if (this.PreonboardinSetupDetail.JoiningDate != null) {
            this.PreonboardinSetupDetail.JoiningDate = this.dateFormat.parse(this.PreonboardinSetupDetail.JoiningDate);
          }

          // if (this.PreonboardinSetupDetail.ProbationDate != null) {
          //   this.PreonboardinSetupDetail.ProbationDate = this.dateFormat.parse(this.PreonboardinSetupDetail.ProbationDate);
          // }

          if (this.PreonboardinSetupDetail.ClientId != null || this.PreonboardinSetupDetail.ClientId > 0) {
            this.ComboLoad('Client', false);
          }
          if (this.PreonboardinSetupDetail.ClientId != null || this.PreonboardinSetupDetail.ClientId > 0 || this.PreonboardinSetupDetail.SiteId != null || this.PreonboardinSetupDetail.SiteId > 0) {
            this.ComboLoad('Site', false);
          }
          if (this.PreonboardinSetupDetail.SiteId != null || this.PreonboardinSetupDetail.SiteId > 0 || this.PreonboardinSetupDetail.DesignationId != null || this.PreonboardinSetupDetail.DesignationId > 0) {
            this.ComboLoad('Designation', false);
          }
          if (this.PreonboardinSetupDetail.DesignationId != null || this.PreonboardinSetupDetail.DesignationId > 0 || this.PreonboardinSetupDetail.DutyId != null || this.PreonboardinSetupDetail.DutyId > 0) {
            this.ComboLoad('Duty', false);
          }
          if (this.PreonboardinSetupDetail.FirstApproverId != null || this.PreonboardinSetupDetail.FirstApproverId > 0 || this.PreonboardinSetupDetail.FirstApproverId != null || this.PreonboardinSetupDetail.FirstApproverId > 0) {
            this.ComboLoad('Approval1', false);
          }
          if (this.PreonboardinSetupDetail.SecondApproverId != null || this.PreonboardinSetupDetail.SecondApproverId > 0 || this.PreonboardinSetupDetail.SecondApproverId != null || this.PreonboardinSetupDetail.SecondApproverId > 0) {
            this.ComboLoad('Approval2', false);
          }
        }
        this.PreonboardinSetupDetail.IsDraft = true;
        this.PreonboardinSetupDetail.SelectType = 'U';

        this.ComboLoad('ServiceType', false);
        this.ComboLoad('Branch', false);
        //this.ComboLoad('Approval1', false);
        this.ComboLoad('Shift', false);
        //this.ComboLoad('Approval2',false);
        if (this.common.ToLowerCase(this.PreonboardinSetupDetail.EmpType) == 'back') {
          this.ComboLoad('Designation', false);
        }
        this.SelectDate('PreJoiningDate', null, null);
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
    // this.employeeRegistration.EmpRegSelectGetData({ 'SelectType': TabName, 'EmpMasterId': this.PreonboardinSetupDetail.EmpMasterId, 'IsDraft': true }).subscribe({
    //   next: (response) => {
    //     if (response.Table.toString() != '') {
    //       this.PreonboardinSetupDetail = response.Table[0];
    //       if (this.PreonboardinSetupDetail.EmpServiceTypeId == 0 || this.PreonboardinSetupDetail.EmpServiceTypeId == '') {
    //         this.PreonboardinSetupDetail.EmpServiceTypeId = null
    //       }
    //       if (this.PreonboardinSetupDetail.BranchID == 0 || this.PreonboardinSetupDetail.BranchID == '') {
    //         this.PreonboardinSetupDetail.BranchID = null
    //       }
    //       if (this.PreonboardinSetupDetail.ClientId == 0 || this.PreonboardinSetupDetail.ClientId == '') {
    //         this.PreonboardinSetupDetail.ClientId = null
    //       }
    //       if (this.PreonboardinSetupDetail.SiteId == 0 || this.PreonboardinSetupDetail.SiteId == '') {
    //         this.PreonboardinSetupDetail.SiteId = null
    //       }
    //       if (this.PreonboardinSetupDetail.DesignationId == 0 || this.PreonboardinSetupDetail.DesignationId == '') {
    //         this.PreonboardinSetupDetail.DesignationId = null
    //       }

    //       if (this.PreonboardinSetupDetail.JoiningDate != null) {
    //         this.PreonboardinSetupDetail.JoiningDate = this.dateFormat.parse(this.PreonboardinSetupDetail.JoiningDate);
    //       }

    //       if (this.PreonboardinSetupDetail.ProbationDate != null) {
    //         this.PreonboardinSetupDetail.ProbationDate = this.dateFormat.parse(this.PreonboardinSetupDetail.ProbationDate);
    //       }

    //       if (this.PreonboardinSetupDetail.ClientId != null || this.PreonboardinSetupDetail.ClientId > 0) {
    //         this.ComboLoad('Client', false);
    //       }
    //       if (this.PreonboardinSetupDetail.SiteId != null || this.PreonboardinSetupDetail.SiteId > 0) {
    //         this.ComboLoad('Site', false);
    //       }
    //       if (this.PreonboardinSetupDetail.DesignationId != null || this.PreonboardinSetupDetail.DesignationId > 0) {
    //         this.ComboLoad('Designation', false);
    //       }
    //     }
    //     this.PreonboardinSetupDetail.IsDraft = true;
    //     this.PreonboardinSetupDetail.SelectType = 'U';

    //     this.ComboLoad('ServiceType', false);
    //     this.ComboLoad('Branch', false);
    //     this.ComboLoad('Approval1', false);
    //     //this.ComboLoad('Approval2',false);
    //     if (this.common.ToLowerCase(this.PreonboardinSetupDetail.EmpType) == 'back') {
    //       this.ComboLoad('Designation', false);
    //     }

    //     this.isDisabled = false;
    //   },
    //   complete: () => { },
    //   error: (error) => {
    //     this.isDisabled = false;
    //   },
    // });
  }

  Validate(form: any) {
    if (form.valid) {
      this.SaveEmpPreOnBoarding();
    }
    else {
      form.submitted = true;
    }
  }

  setIsReportingToNotApplicable() {
    if (this.PreonboardinSetupDetail.DesignationId > 0) {
      if (this.Designations.length > 0) {
        this.IsReportingToNotApplicable = this.Designations.filter((e: any) => e.DesignationMasterID == this.PreonboardinSetupDetail.DesignationId)[0].IsReportingToNotApplicable;
      } else {
        this.IsReportingToNotApplicable = false;
      }
    } else {
      this.IsReportingToNotApplicable = false;
    }
  }

  close() {
    if (window.location.href.toString().includes('candidateinitiation')) {
      this.router.navigate(['/onboarding/candidateinitiation/' + this.common.ToLowerCase(this.PreonboardinSetupDetail.EmpType)]);
    } else {
      this.router.navigate(['/onboarding/preonboarding/' + this.common.ToLowerCase(this.PreonboardinSetupDetail.EmpType)]);
    }
  }
}
